import React, { useEffect, useState } from "react";
import {
  Table, TableHead, TableRow, TableCell, TableBody,
  Typography, CircularProgress, Paper, Box, Button
} from "@mui/material";
import axios from "axios";
import { BASE_URL } from "../../App";
import { useSearchParams } from "react-router-dom";
import * as XLSX from "xlsx"; // Importing the xlsx library

const UnmappedDealers = () => {
  const [dealers, setDealers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [branchCode, setBranchCode] = useState("");
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get("branchCode");
    console.log("Extracted branchCode from URL:", code);

    if (code) {
      setBranchCode(code);
    }
  }, [searchParams]);

  useEffect(() => {
    if (branchCode) {
      fetchUnmappedDealers(branchCode);
    }
  }, [branchCode]);

  const fetchUnmappedDealers = async (code) => {
    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/getUnmappedDealers`, {
        branchCode: code,
      });

      const dealersList = response?.data?.dealers;
      if (Array.isArray(dealersList)) {
        setDealers(dealersList);
      } else {
        setDealers([]);
      }
    } catch (error) {
      console.error("Error fetching dealers:", error);
      setDealers([]);
    } finally {
      setLoading(false);
    }
  };

  // Function to download data as Excel
  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(dealers);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Unmapped Dealers");

    // Save the Excel file
    XLSX.writeFile(workbook, "Unmapped_Dealers.xlsx");
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Unmapped Dealers for Branch: {branchCode}
      </Typography>

      <Box sx={{ mb: 2 }}>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={downloadExcel}
        >
          Download Excel
        </Button>
      </Box>

      {loading ? (
        <CircularProgress />
      ) : (
        <Paper sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#ADD8E6" }}>
                <TableCell sx={{ fontWeight: "bold" }}>Dealer Code</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Dealer Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dealers.length > 0 ? (
                dealers.map((dealer, index) => (
                  <TableRow key={index}>
                    <TableCell>{dealer.DealerCode}</TableCell>
                    <TableCell>{dealer.DealerName}</TableCell>
                    <TableCell>{dealer.Status}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No unmapped dealers found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Box>
  );
};

export default UnmappedDealers;
